var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9401 5.42043L13.7701 2.43043C12.7801 1.86043 11.2301 1.86043 10.2401 2.43043L5.02008 5.44043C2.95008 6.84043 2.83008 7.05043 2.83008 9.28043V14.7104C2.83008 16.9404 2.95008 17.1604 5.06008 18.5804L10.2301 21.5704C10.7301 21.8604 11.3701 22.0004 12.0001 22.0004C12.6301 22.0004 13.2701 21.8604 13.7601 21.5704L18.9801 18.5604C21.0501 17.1604 21.1701 16.9504 21.1701 14.7204V9.28043C21.1701 7.05043 21.0501 6.84043 18.9401 5.42043ZM12.0001 15.2504C10.2101 15.2504 8.75008 13.7904 8.75008 12.0004C8.75008 10.2104 10.2101 8.75043 12.0001 8.75043C13.7901 8.75043 15.2501 10.2104 15.2501 12.0004C15.2501 13.7904 13.7901 15.2504 12.0001 15.2504Z",
    fill: "url(#paint0_linear_2732_27074)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2732_27074",
    x1: 4.26579,
    y1: -1.77438,
    x2: 4.26578,
    y2: 30.2216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8092e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38499b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingEnabled);
export default __webpack_public_path__ + "static/media/setting-enabled.26c2cdb9c84a561ddb7eb19e0a1e3788.svg";
export { ForwardRef as ReactComponent };